import React, { useState } from "react";
import { Link } from "react-router-dom";
import sidebar__banner from "../../assets/img/sidebar-banner.png";
import img from "../../assets/img/sidebar-rounded.png";
import { AngleDown, BinanceIcon } from "../../icon/IconTheme";
import CountdownItem from "../CountdownItem";

const data = [
	{
		title: "Items",
		icon: "",
		count: "124",
	},
	{
		title: "Floor Price",
		icon: <BinanceIcon />,
		count: "0.8576",
	},
	{
		title: "Volume Traded",
		icon: <BinanceIcon />,
		count: "145.786",
	},
];

const SidebarTop = () => {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	return (
		<div className="sidebar-top">
			<div className="sidebar-banner">
				<img src={sidebar__banner} alt="" />
			</div>
			<Link to="#" className="rounded-img">
				<img src={img} alt="" />
			</Link>
			<div className="sidebar-inner">
				<h4 className="title text-center position-relative">
					<Link className="text-white" to="#">
						Nakamotos <AngleDown />
					</Link>
					<ul
						className={`__dropdown-menu dropdown-menu ${
							dropdownOpen ? "active" : ""
						}`}
						onClick={() => setDropdownOpen(false)}
						onMouseDown={() => setDropdownOpen(true)}
					>
						<li>
							<Link className="dropdown-item" to="#">
								Hashimon
							</Link>
						</li>
						<li>
							<Link className="dropdown-item" to="#">
								Hashima
							</Link>
						</li>
					</ul>
				</h4>
				<div className="text">
					Lorem Ipsum is simply dummy text of the printing and typesetting
					industry
				</div>
				<div className="sidebar-info-area">
					{data &&
						data.map(({ title, icon, count }, i) => (
							<div className="sidebar-info-item" key={i}>
								{count && (
									<h4 className="count">
										{icon && icon} {count}
									</h4>
								)}
								{title && <div>{title}</div>}
							</div>
						))}
				</div>
				<div className="sidebar-top-bid">
					<div className="subtxt">Current Bid</div>
					<div className="bid-txt d-flex justify-content-between">
						<h6>31.42 BNB</h6>
						<span>$98,653.74</span>
					</div>
				</div>
				<CountdownItem targetDate={`December 30, 2022 00:00:00`} />
			</div>
		</div>
	);
};

export default SidebarTop;
